import React from "react";
import classnames from "classnames";
import { View } from "@instructure/ui-view";
import { Flex } from "@instructure/ui-flex";
import { Button } from "@instructure/ui-buttons";
import { IconResetLine, IconUploadLine } from "@instructure/ui-icons";
import FormActionsLoader from "../FormActionsLoader/FormActionsLoader";
import styles from "./FormActions.module.scss";

const IasFormActions = ({
                            onReset,
                            onSubmit,
                            isLoading,
                            disableReset,
                            disableSubmit
                        }) => {
    return (
        <View as="footer" className={styles.FormActions}>
            <Flex justifyItems="end">
                <Flex.Item size="20rem" position="relative">
                    <FormActionsLoader hide={!isLoading} />

                    <Flex justifyItems="space-between">
                        <Flex.Item size="9rem">
                            <Button
                                type="reset"
                                interaction={isLoading || disableReset ? "disabled" : "enabled"}
                                className={classnames(styles.FormActionsButton)}
                                renderIcon={<IconResetLine size="x-small" />}
                                color={"primary-inverse"}
                                display="block"
                                onClick={onReset}
                            >
                                Reset
                            </Button>
                        </Flex.Item>
                        <Flex.Item size="9rem">
                            <Button
                                type="submit"
                                interaction={
                                    isLoading || disableSubmit ? "disabled" : "enabled"
                                }
                                className={classnames(styles.FormActionsButton)}
                                renderIcon={IconUploadLine}
                                color={"primary"}
                                margin="x-small"
                                size="medium"
                                display="block"
                                onClick={onSubmit}
                            >
                                Submit
                            </Button>
                        </Flex.Item>
                    </Flex>
                </Flex.Item>
            </Flex>
        </View>
    );
};

export default IasFormActions;
